// Display Banner Ads - mowPod Tactic
// Handles form management for this specific tactic

document.addEventListener('alpine:init', () => {
  Alpine.data('display_banner_ads_mowpod_x_data', () => ({
    // Form data
    formData: {
      targeting: {
        countries: [],
        podcast_categories: []
      }
    },
    
    init() {
      // Use $nextTick to ensure DOM is fully rendered before loading saved data
      this.$nextTick(() => {
        // Load saved configuration data if available
        this.loadSavedConfiguration();
      });
    },
    
    // Load saved configuration from backend
    loadSavedConfiguration() {
      try {
        const savedDataDiv = this.$refs.savedConfigData;
        
        if (savedDataDiv) {
          if (savedDataDiv.dataset.savedConfig) {
            const savedConfig = JSON.parse(savedDataDiv.dataset.savedConfig);
            
            if (savedConfig) {
              // Load targeting data
              if (savedConfig.targeting) {
                if (savedConfig.targeting.countries) {
                  this.formData.targeting.countries = savedConfig.targeting.countries;
                }
                if (savedConfig.targeting.podcast_categories) {
                  this.formData.targeting.podcast_categories = savedConfig.targeting.podcast_categories;
                }
              }
            }
          }
        }
        
      } catch (error) {
        console.error('Error loading saved configuration:', error);
      }
    },
    
    // Add country to selection
    addCountry(country) {
      if (country && !this.formData.targeting.countries.includes(country)) {
        this.formData.targeting.countries.push(country);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-country-select]');
        if (selectElement) selectElement.value = '';
      }
    },
    
    // Remove country from selection
    removeCountry(country) {
      const index = this.formData.targeting.countries.indexOf(country);
      if (index > -1) {
        this.formData.targeting.countries.splice(index, 1);
      }
    },
    
    // Add podcast category to selection
    addPodcastCategory(category) {
      if (category && !this.formData.targeting.podcast_categories.includes(category)) {
        this.formData.targeting.podcast_categories.push(category);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-podcast-category-select]');
        if (selectElement) selectElement.value = '';
      }
    },
    
    // Remove podcast category from selection
    removePodcastCategory(category) {
      const index = this.formData.targeting.podcast_categories.indexOf(category);
      if (index > -1) {
        this.formData.targeting.podcast_categories.splice(index, 1);
      }
    },
    
    // Format category for display (convert snake_case to Title Case)
    formatCategoryDisplay(category) {
      if (!category) return '';
      return category
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
    },
    
    // Save form configuration (marks as complete)
    submitForm() {
      try {
        // Validate required fields
        if (this.formData.targeting.countries.length === 0) {
          alert('Please select at least one country for targeting.');
          return;
        }
        
        if (this.formData.targeting.podcast_categories.length === 0) {
          alert('Please select at least one podcast category.');
          return;
        }
        
        // Prepare data for submission
        const formDataToSubmit = {
          targeting: {
            countries: this.formData.targeting.countries,
            podcast_categories: this.formData.targeting.podcast_categories
          }
        };
        
        // Get the campaign tactic ID from the routes div
        const routesDiv = this.$refs.routes;
        const submitLink = routesDiv?.dataset?.submitLink;
        
        if (!submitLink) {
          alert('Submit link not found. Please refresh the page and try again.');
          return;
        }
        
        // Create a hidden form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = submitLink;
        
        // Add CSRF token
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (csrfToken) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = 'authenticity_token';
          csrfInput.value = csrfToken;
          form.appendChild(csrfInput);
        }
        
        // Add method override for PATCH
        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'PATCH';
        form.appendChild(methodInput);
        
        // Add form data as JSON
        const formDataInput = document.createElement('input');
        formDataInput.type = 'hidden';
        formDataInput.name = 'form_data';
        formDataInput.value = JSON.stringify(formDataToSubmit);
        form.appendChild(formDataInput);
        
        // Add to DOM and submit
        document.body.appendChild(form);
        form.submit();
        
      } catch (error) {
        console.error('Error saving form:', error);
        alert('Error saving configuration. Please try again.');
      }
    },

    // Save as draft (no validations, marks as incomplete)
    saveAsDraft() {
        // Prepare data for submission (same as submitForm but without validations)
        const formDataToSubmit = {
          targeting: {
            countries: this.formData.targeting.countries,
            podcast_categories: this.formData.targeting.podcast_categories
          }
        };
        
        // Get the save as draft link from the routes template
        const routesTemplate = this.$refs.routes;
        const saveAsDraftLink = routesTemplate?.dataset?.saveAsDraftLink;
        
        // Create a hidden form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = saveAsDraftLink;
        
        // Add CSRF token
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (csrfToken) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = 'authenticity_token';
          csrfInput.value = csrfToken;
          form.appendChild(csrfInput);
        }
        
        // Add method override for PATCH
        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'PATCH';
        form.appendChild(methodInput);
        
        // Add form data as JSON
        const formDataInput = document.createElement('input');
        formDataInput.type = 'hidden';
        formDataInput.name = 'form_data';
        formDataInput.value = JSON.stringify(formDataToSubmit);
        form.appendChild(formDataInput);
        
        // Add to DOM and submit
        document.body.appendChild(form);
        form.submit();
    }
  }));
});
